export const SearchElements = {
	autoSuggestId: 'autoSuggestId',
	qsSearchHelp: 'qsHelp',
	searchBtnId: 'searchBtnId',
	autoSuggestPlaceholder: 'Name, Customer ID, Account no or Plan',
	clientSearchContainer: 'client-Search-container',
	clientSearchHeader: 'client-search-header',
	viewClientGroup: 'viewClientGroup',
	advancedSearch: 'advanced-search',
};
